export enum SymbolType {
  NN = -1,
  Wild = 0, // wild
  H1 = 1, // 橘色權杖
  H2 = 2, // 黃色權杖
  H3 = 3, // 綠色書本
  H4 = 4, // 紫色權杖
  L1 = 5, // 紅寶
  L2 = 6, // 黃寶
  L3 = 7, // 綠寶
  L4 = 8, // 紫寶
  L5 = 9, // 藍寶
  C1 = 44, // 還沒分顏色的收集 (不會拿到)
  S1 = 55, // multiplier
  C1Expanding = 66,
  C1Multiplier = 77,
  C1Wild = 88,
}

export enum multiplierSymbol {
  M1 = 8,
  M2 = 20,
  M3 = 100,
  M4 = 501,
}
